import type { ApiFetchLastGamesPort } from './ports/api-fetch-last-games.port';

export class FetchLastGamesHandler {
  // eslint-disable-next-line no-useless-constructor
  constructor(private apiFetchLastGamesPort: ApiFetchLastGamesPort) {}

  async handle(userId: number) {
    return await this.apiFetchLastGamesPort.handle(userId);
  }
}
